<!--Title-->
<h3>
  {{ "_General_Lobby_Editor_Text_" | translate }}
</h3>

<div class="cc-content-wrapper lobby-editor-wrapper">
  <div class="cc-single-tab">
    <div class="k-overlay" *ngIf="FiltersPopupOpened"></div>
    <div kendoWindowContainer></div>
    <!--Header-->
    <form class="form-horizontal" [formGroup]="detailViewForm">
      <div class="row cc-action-panel" *ngIf="initialReportExecutionComplete">
        <div class="cc-filters align-items-end">
          <div class="me-3">
            <label>{{ "_General_Filter_Text_" | translate }}</label>
            <select
              #filterList
              id="filterList"
              class="cc-select-dropdown filter-list limited-width"
              placeholder="Select"
              formControlName="activeFilterTemplate"
              (change)="activeTemplateChanged(filterList.value)"
            >
              <option
                *ngFor="let value of commonData.templates"
                [ngValue]="value.templateName"
              >
                {{
                  value.templateName == "None"
                    ? ("_Report_Filter_None_Ts_Text_" | translate)
                    : value.templateName
                }}
              </option>
            </select>
          </div>

          <div class="me-3">
            <button class="btn btn-secondary" (click)="goToFilterOptions()">
              {{ "_General_FilterOption_Text_" | translate }}
            </button>
          </div>
        </div>

        <div class="cc-filters ms-3 d-flex align-items-end">
          <div class="me-3 ms-3 d-flex align-items-center">
            <div class="me-2">
              <label>
                {{ "_General_From_Text_" | translate }}
              </label>
              <kendo-datepicker
                class="date-picker"
                id="from"
                formControlName="from"
                [disabledDates]="isDateDisabled.bind(this)"
                [readOnlyInput]="true"
                [navigation]="false"
                calendarType="infinite"
                (valueChange)="fromDateChange()"
              >
                <kendo-datepicker-messages
                  today="{{ '_General_Today_Text_' | translate }}"
                  toggle="{{ '_General_Toggle_Calendar_Text_' | translate }}"
                  parentViewButtonTitle="{{
                    '_General_Navigate_To_Parent_View_Text_' | translate
                  }}"
                >
                </kendo-datepicker-messages>
              </kendo-datepicker>
            </div>
            <div>
              <label>{{ "_General_To_Text_" | translate }}</label>
              <kendo-datepicker
                class="date-picker"
                id="to"
                formControlName="to"
                [disabledDates]="isDateDisabled.bind(this)"
                [readOnlyInput]="true"
                [navigation]="false"
                calendarType="infinite"
                (valueChange)="toDateChange()"
              >
                <kendo-datepicker-messages
                  today="{{ '_General_Today_Text_' | translate }}"
                  toggle="{{ '_General_Toggle_Calendar_Text_' | translate }}"
                  parentViewButtonTitle="{{
                    '_General_Navigate_To_Parent_View_Text_' | translate
                  }}"
                ></kendo-datepicker-messages>
              </kendo-datepicker>
            </div>
          </div>
          <button
            class="btn btn-primary"
            (click)="runReportDirect()"
            [disabled]="isReportRunning"
          >
            {{ "_Report_Lobby_Run_Report_Text_" | translate }}
          </button>
        </div>
      </div>

      <div class="row view-selector">
        <div
          class="col-md-12 d-flex justify-content-center"
          *ngIf="loadingEditorData == 0"
        >
          <label id="lastRefreshed" class="last-refreshed-message mt-1 mb-3">{{
            LastRefreshed
          }}</label>
        </div>
        <!--<div class="col-md-2" *ngIf="loading == 0">
        </div>
        <div class="col-md-2" *ngIf="loading > 0 && initialReportExecutionComplete == true" >
        </div>
        <div class="col-md-6" *ngIf="loading > 0 && initialReportExecutionComplete == true">
          <label id="loadingPrompt" class="loading-prompt" *ngIf="loading > 0">{{loadingPrompt}}</label>
        </div>
        <div class="col-md-12 initial-loading-prompt" *ngIf="loading > 0">
          <label id="loadingPrompt" class="loading-prompt" *ngIf="loading > 0">{{loadingPrompt}}</label>
        </div>-->
      </div>
    </form>
    <!-- <div *ngIf="loading > 0" class="d-flex justify-content-center">
      <div class="spinner-border" role="status">
        <span></span>
      </div>
    </div> -->
    <div
      class="d-flex align-items-center mb-3 justify-content-between grid-btn-panel"
      *ngIf="initialReportExecutionComplete"
    >
      <div class="btn-panel-left d-flex align-items-center">
        <button
          type="button"
          class="btn btn-primary"
          icon="delete"
          (click)="openDeleteLobbyEntriesDialog(lobbyEntriesDelete)"
          [disabled]="
            this.isUserCanEditGrid == false || this.selectedKeys.length == 0
          "
        >
          {{ "_Report_Lobby_Delete_Selected_Text_" | translate }}
        </button>
        <button
          id="lobbyEditorExpandCollapseRowsToggleBtn"
          type="button"
          class="btn btn-primary"
          icon="expand"
          (click)="onExpandCollapseToggleClick()"
        >
          <ng-container *ngIf="areAllRowsExpanded">{{
            "_Report_Filter_Collapse_Text_" | translate
          }}</ng-container>
          <ng-container *ngIf="!areAllRowsExpanded">{{
            "_Report_Filter_Expand_Text_" | translate
          }}</ng-container>
          {{ "_General_All_Text_" | translate }}
        </button>
      </div>
      <div class="btn-panel-right d-flex align-items-center">
        <div class="cc-search">
          <input
            [(ngModel)]="filterText"
            class="form-control"
            (keydown.enter)="onFilterTextEnterKeyPress($event)"
            placeholder="{{ '_General_Search_Text_' | translate }}"
            required
          />
          <button
            [ngClass]="{ 'show-btn': showClearButton }"
            (click)="onClearSearchTextClicked()"
            class="cc-close-btn"
          >
            <span class="fas fa-times"></span>
          </button>
          <button (click)="onFilterTextSearchClicked()" class="cc-search-btn">
            <span class="fas fa-search"></span>
          </button>
        </div>
        <button
          type="button"
          class="btn btn-primary ms-auto"
          icon="file-csv"
          (click)="exportToCsv()"
        >
          {{ "_Report_Lobby_Export_Text_" | translate }}
        </button>
      </div>
    </div>
    <div class="initial-loading-prompt col-md-12" *ngIf="loadingEditorData > 0">
      <label
        id="loadingPrompt"
        class="loading-prompt"
        *ngIf="loadingEditorData > 0"
        >{{ loadingPrompt }}</label
      >
    </div>

    <div class="lobby-editor-grid" *ngIf="initialReportExecutionComplete">
      <kendo-grid
        #grid="kendoGrid"
        [data]="gridData"
        [pageSize]="pageSize"
        [skip]="skip"
            [sortable]="{ allowUnsort: false, mode: 'single' }"
        [sort]="sort"
        [selectable]="{ checkboxOnly: true, mode: 'multiple' }"
        kendoGridSelectBy="lobbyEntryId"
        [selectedKeys]="selectedKeys"
        (selectionChange)="onSelectionChange($event)"
        [pageable]="{ pageSizes: [10, 20, 30, 50, 100] }"
        scrollable="none"
        (pageChange)="pageChange($event)"
        (sortChange)="sortChange($event)"
        (excelExport)="onExcelExport($event)"
      >
        <kendo-grid-messages
          pagerItemsPerPage="{{ '_Items_Per_Page_Text_' | translate }}"
          pagerFirstPage="{{ '_Go_To_First_Page_Text_' | translate }}"
          pagerLastPage="{{ '_Go_To_Last_Page_Text_' | translate }}"
          pagerNextPage="{{ '_Go_To_Next_Page_Text_' | translate }}"
          pagerPreviousPage="{{ '_Go_To_Previous_Page_Text_' | translate }}"
          pagerPage="{{ '_Page_Grid_Text_' | translate }}"
          noRecords="{{ '_NoRecords_Grid_Text_' | translate }}"
          pagerItems="{{
            '_General_Kendo_Grid_Pageable_Items_Text_' | translate
          }}"
          pagerOf="{{ '_General_Kendo_Grid_Pageable_Of_Text_' | translate }}"
        ></kendo-grid-messages>

        <kendo-grid-checkbox-column
          [showSelectAll]="true"
          [width]="6"
          [headerClass]="{ 'text-center': true }"
          [class]="{ 'text-center': true }"
        ></kendo-grid-checkbox-column>
        <!--kendo-grid-column title="{{'_Lobby_Wrap_Up_Lobby_ID_Text_' | translate}}" field="lobbyEntryId" [width]="50"></kendo-grid-column-->
        <!--kendo-grid-column field="type" [sortable]="false" title="{{'_General_Type_Text_' | translate }}" [width]="6">
          <ng-template kendoGridCellTemplate let-dataItem>
            <div class="d-flex align-items-center">
              <div class="lobby-grid-icon-area">
                <button *ngIf="dataItem.type == 'Walk-In'" class="cc-icon-btn cursor" title="{{'_General_Report_WalkIn_Text_' | translate }}">
                  <span class="fas fa-walking walk-in-icon"></span>
                </button>
                <button *ngIf="dataItem.type == 'Appointment'" class="cc-icon-btn cursor"
                  title="{{'_General_Report_Appointment_Text_' | translate }}">
                  <img class="in-person-appointment-icon" src="assets/images/icon/in-person-appointment.svg" />
                </button>
              </div>
            </div>
          </ng-template>
        </kendo-grid-column-->
        <kendo-grid-column
          title="{{ '_General_Report_CheckinTime_Text_' | translate }}"
          field="addedTime"
          [width]="6"
          format="MM/dd/yyyy"
        ></kendo-grid-column>
        <kendo-grid-column
          title="{{ '_General_Location_Text_' | translate }}"
          field="location"
          [width]="6"
        ></kendo-grid-column>
        <kendo-grid-column
          title="{{ '_Account_Number_Field_Text_' | translate }}"
          field="accountNumber"
          *ngIf="commonData.lobbyConfiguration.enableAccountNumber"
          [width]="6"
        ></kendo-grid-column>
        <kendo-grid-column
          title="{{ '_General_Report_AccountName_Text_' | translate }}"
          field="accountName"
          [width]="6"
        ></kendo-grid-column>
        <kendo-grid-column
          title="{{ '_General_Confirmation_Text_' | translate }} #"
          field="confirmationNumber"
          [width]="6"
          *ngIf="isACLicenseEnabled$ | async"
        ></kendo-grid-column>
        <kendo-grid-column
          title="{{ '_General_Report_Requested_Items_Text_' | translate }}"
          field="requestedService"
        ></kendo-grid-column>
        <kendo-grid-column
          title="{{ '_General_Report_Requested_Staff_Text_' | translate }}"
          field="userRequested"
          [width]="6"
        ></kendo-grid-column>
        <kendo-grid-column
          title="{{ '_General_Report_MainAssisted_Staff_Text_' | translate }}"
          field="mainAssistedBy"
          [width]="6"
        ></kendo-grid-column>
        <kendo-grid-column
          title="{{ '_General_Report_Wait_Time_Text_' | translate }}"
          field="lobbyEntryWaitTime"
          [width]="6"
        ></kendo-grid-column>
        <kendo-grid-column
          title="{{ '_General_Report_Assist_Time_Text_' | translate }}"
          field="serviceTime"
          [width]="6"
        ></kendo-grid-column>
        <kendo-grid-column
          title="{{ '_General_Report_WrapUpTime_Text_' | translate }}"
          field="wrapUpTime"
          [width]="6"
        ></kendo-grid-column>
        <kendo-grid-column
          title="{{ '_General_Report_Interaction_Time_Text_' | translate }}"
          field="interactionTime"
          [width]="6"
        ></kendo-grid-column>
        <kendo-grid-column
          title="{{ '_General_Report_AutoWrapUp_Text_' | translate }}"
          field="autoWrapUp"
          [width]="6"
        >
          <ng-template kendoGridCellTemplate let-dataItem>{{
            dataItem.autoWrapUp === "Yes"
              ? ("_General_Action_Label_Yes_Text_" | translate)
              : ("_General_Action_Label_No_Text_" | translate)
          }}</ng-template>
        </kendo-grid-column>
        <kendo-grid-column
          title="{{ '_General_Status_Text_' | translate }}"
          field="status"
          [width]="6"
        >
          <ng-template kendoGridCellTemplate let-dataItem>{{
            dataItem.status === "Completed"
              ? ("_General_Completed_Text_" | translate)
              : dataItem.status === "No Show"
                ? ("_General_No_Show_Text_" | translate)
                : ("_General_LWA_Abbr_Text_" | translate)
          }}</ng-template>
        </kendo-grid-column>
        <kendo-grid-command-column
          title="{{ '_General_Button_Action_Text_' | translate }}"
          [width]="6"
        >
          <ng-template kendoGridCellTemplate let-dataItem>
            <button
              kendoGridEditCommand
              (click)="openLobbyDetailEdit(lobbyDetailEdit, dataItem)"
              class="cc-icon-btn edit"
              title="{{
                (isUserCanEditGrid
                  ? '_General_Button_Edit_Text_'
                  : '_General_View_Text_'
                ) | translate
              }}"
            >
              <span class="fas fa-pen" *ngIf="isUserCanEditGrid"></span>
              <span class="fas fa-eye" *ngIf="!isUserCanEditGrid"></span>
            </button>
          </ng-template>
        </kendo-grid-command-column>
        <ng-template kendoGridDetailTemplate let-dataItem>
          <kendo-grid [data]="dataItem.servicesProvided" scrollable="none">
            <kendo-grid-messages
              pagerFirstPage="{{ '_Go_To_First_Page_Text_' | translate }}"
              pagerLastPage="{{ '_Go_To_Last_Page_Text_' | translate }}"
              pagerNextPage="{{ '_Go_To_Next_Page_Text_' | translate }}"
              pagerPreviousPage="{{ '_Go_To_Previous_Page_Text_' | translate }}"
              pagerPage="{{ '_Page_Grid_Text_' | translate }}"
              noRecords="{{ '_NoRecords_Grid_Text_' | translate }}"
              pagerItems="{{
                '_General_Kendo_Grid_Pageable_Items_Text_' | translate
              }}"
              pagerOf="{{
                '_General_Kendo_Grid_Pageable_Of_Text_' | translate
              }}"
            ></kendo-grid-messages>

            <kendo-grid-column
              title="{{ '_General_Report_Product/Service_Text_' | translate }}"
              field="serviceName"
            ></kendo-grid-column>
            <kendo-grid-column
              title="{{ '_General_Report_Requested_Text_' | translate }}"
              field="requested"
              [width]="90"
            ></kendo-grid-column>
            <kendo-grid-column
              title="{{ '_General_Report_ReferenceNumber_Text_' | translate }}"
              field="referenceNumber"
            ></kendo-grid-column>
            <kendo-grid-column
              title="{{ '_General_Report_AssistedBy_Text_' | translate }}"
              field="assistedBy"
            ></kendo-grid-column>
            <kendo-grid-column
              title="{{ '_General_Report_Wait_Time_Text_' | translate }}"
              field="waitTime"
              [width]="130"
            ></kendo-grid-column>
            <kendo-grid-column
              title="{{ '_General_Report_Assist_Time_Text_' | translate }}"
              field="serviceTime"
              [width]="130"
            ></kendo-grid-column>
            <kendo-grid-column
              title="{{ '_General_Report_WrapUpTime_Text_' | translate }}"
              field="wrapUpTime"
              [width]="130"
            ></kendo-grid-column>
            <kendo-grid-column
              title="{{ '_General_Report_Interaction_Time_Text_' | translate }}"
              field="interactionTime"
              [width]="130"
            ></kendo-grid-column>
          </kendo-grid>
        </ng-template>
        <kendo-grid-excel
          fileName="LobbyEditorExport.xlsx"
          [fetchData]="allData"
        >
          <kendo-excelexport-column
            title="{{ '_General_Report_Id_Text_' | translate }}"
            field="lobbyEntryId"
          ></kendo-excelexport-column>
          <kendo-excelexport-column
            title="{{ '_General_Type_Text_' | translate }}"
            field="type"
            [width]="40"
          ></kendo-excelexport-column>
          <kendo-excelexport-column
            title="{{ '_General_Report_CheckinTime_Text_' | translate }}"
            field="addedTime"
            format="MM/dd/yyyy"
          ></kendo-excelexport-column>
          <kendo-excelexport-column
            title="{{ '_General_Report_Assisted_Time_Text_' | translate }}"
            field="assistedTime"
          ></kendo-excelexport-column>
          <kendo-excelexport-column
            title="{{ '_General_Report_Completed_Time_Text_' | translate }}"
            field="completedTime"
            format="MM/dd/yyyy"
          ></kendo-excelexport-column>
          <kendo-excelexport-column
            title="{{ '_General_Location_Text_' | translate }}"
            field="location"
          ></kendo-excelexport-column>
          <kendo-excelexport-column
            title="{{ '_Account_Number_Field_Text_' | translate }}"
            field="accountNumber"
            *ngIf="commonData.lobbyConfiguration.enableAccountNumber"
          ></kendo-excelexport-column>
          <kendo-excelexport-column
            title="{{ '_General_Report_AccountName_Text_' | translate }}"
            field="accountName"
          ></kendo-excelexport-column>
          <kendo-excelexport-column
            title="Testerrrrrr"
            field="confirmationNumber"
          ></kendo-excelexport-column>
          <kendo-excelexport-column
            title="{{ '_General_Report_Requested_Staff_Text_' | translate }}"
            field="userRequested"
          ></kendo-excelexport-column>
          <kendo-excelexport-column
            title="{{ '_General_Report_AutoWrapUp_Text_' | translate }}"
            field="autoWrapUp"
          ></kendo-excelexport-column>
          <kendo-excelexport-column
            title="{{ '_General_Status_Text_' | translate }}"
            field="status"
          ></kendo-excelexport-column>
          <kendo-excelexport-column
            title="{{ '_General_Report_Comments_Text_' | translate }}"
            field="comments"
          ></kendo-excelexport-column>
          <kendo-excelexport-column
            title="{{ '_General_Report_Product/Service_Text_' | translate }}"
            field="serviceName"
          ></kendo-excelexport-column>
          <kendo-excelexport-column
            title="{{ '_General_Report_ReferenceNumber_Text_' | translate }}"
            field="serviceName"
          ></kendo-excelexport-column>
          <kendo-excelexport-column
            title="{{ '_General_Report_AssistedBy_Text_' | translate }}"
            field="assistedBy"
          ></kendo-excelexport-column>
          <kendo-excelexport-column
            title="{{ '_General_Report_lwaReason_Text_' | translate }}"
            field="lwaReason"
          ></kendo-excelexport-column>
          <kendo-excelexport-column
            title="{{ '_General_Report_closedBy_Text_' | translate }}"
            field="closedByUser"
          ></kendo-excelexport-column>
        </kendo-grid-excel>
      </kendo-grid>
    </div>
  </div>
</div>

<app-lobby-detail-edit
  #lobbyDetailEdit
  (onEdited)="runReport()"
></app-lobby-detail-edit>
<app-lobby-entries-delete
  #lobbyEntriesDelete
  (onDeleted)="runReport()"
></app-lobby-entries-delete>
<div></div>
